import React from 'react'
import { View, Svg, Line } from '@react-pdf/renderer'

interface SpacerWidgetProps {
    border?: boolean
    height?: number | string
}

const SpacerWidget: React.FC<SpacerWidgetProps> = ({
    border,
    height = 30
}) => {

    let processedHeight = 30

    if (typeof height === 'string') {
        processedHeight = (isNaN(parseInt(height, 10))) ? 30 : parseInt(height, 10)
    } else {
        processedHeight = height
    }

    return (
        <View style={{
            height: processedHeight
        }}>
            {(border) && (
                <Svg height={1} width="100%">
                    <Line x1={0} y1={0} x2="100%" y2={0} style={{ stroke: '#cccccc', strokeWidth: 1 }} />
                </Svg>
            )}
        </View>
    )
}

export { SpacerWidget }
SpacerWidget.displayName = 'Spacer (PDF)'
